import { messages } from "../../i18n/messages.js";
import { AppButton } from "../ui/AppButton.js";

interface CartEmptyStateProps {
  onBrowseCatalog?: () => void;
}

export function CartEmptyState({ onBrowseCatalog }: CartEmptyStateProps) {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-12 text-center">
      <h3 className="text-base font-semibold">{messages.cart.emptyTitle}</h3>
      <p className="max-w-xs text-sm opacity-70">{messages.cart.emptyBody}</p>
      {onBrowseCatalog ? (
        <AppButton onClick={onBrowseCatalog}>{messages.cart.emptyCta}</AppButton>
      ) : null}
    </div>
  );
}
